<ng-container *transloco="let t; read: 'communication-workflow-global-settings'">
  <p-accordion>
    <p-accordionTab [header]="t('accordionTitle')" [selected]="false">
      <app-settings
        [auditEntry]="auditEntry"
        [cardTitle]="t('sectionTitle')"
        [doUpload]="upload"
        [refreshData]="refreshData"
        [resetForm]="resetUI"
      >
        <div class="grid">
          <div class="col-12">
            <p-checkbox [binary]="true" [formControl]="noisyEnvironment" [label]="t('checkboxLabel')"></p-checkbox>
            <app-form-field-help [control]="noisyEnvironment">
              <ng-container form-field-help-hint>
                <span *ngIf="noisyEnvironment.value === true">{{ t('checkboxHelpChecked') }}</span>
                <span *ngIf="noisyEnvironment.value === false">{{ t('checkboxHelpUnchecked') }}</span>
              </ng-container>
            </app-form-field-help>
          </div>
        </div>
      </app-settings>
    </p-accordionTab>
  </p-accordion>
</ng-container>
